// Vloží do hlavičky okna (řádek 2) podtitulek + libovolný obsah (např. stavový badge) přes portál.
// Renderuje se JEN v hlavičce okna — do NÁZVU okna (taskbar/historie) se nic z toho nepromítá
// (tam jde jen titulek přes `useWindowTitle`). Volá komponenta detailu, která je uvnitř okna.

import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { WindowSubtitle } from './WindowSubtitle';
import { useWindowHeaderSlot } from './windowHeaderSlot';

export interface WindowHeaderExtrasProps {
  /** Podtitulek (obalí se do `WindowSubtitle`). */
  readonly subtitle?: ReactNode;
  /** Libovolný další obsah hlavičky (badge, chip, akce…). */
  readonly children?: ReactNode;
}

export function WindowHeaderExtras({ subtitle, children }: WindowHeaderExtrasProps) {
  const slot = useWindowHeaderSlot();
  if (!slot) return null;
  return createPortal(
    <>
      {subtitle != null && subtitle !== '' && <WindowSubtitle>{subtitle}</WindowSubtitle>}
      {children}
    </>,
    slot
  );
}
